<template>
  <footer class="footer-container">
    <span>Arthur Beaubois-Jude</span>
    <span class="carto">Cartographie & Infographie</span>
    <a href="tel:+33616941856">06 16 94 18 56</a>
    <a href="mailto:bonjour@arthurbeauboisjude.com">bonjour@arthurbeauboisjude.com</a>
    <span>Copyright 2026</span>
  </footer>
</template>

<script>
export default {
  name: 'Footer',
};
</script>

<style lang="scss" scoped>
  .footer-container {
    @media (max-width: 900px) {
      font-size: 1.8vw;
    }
    @media (max-width: 768px) {
      font-size: 1.9vw;
    }
    @media (max-width: 576px) {
      font-size: 3.45vw;
    }

    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    font-family: "Moon";
    margin-bottom: 4px;
    font-weight: $font-weight-light;
    border-top: 1px solid $color-black;
    span, a {
      white-space: nowrap;
      color: $color-black;
      margin: 0 1vw;
      font-family: "Moon";
      font-size: $font-size-small;
      @media (max-width: 576px) {
        &.carto::after {
          content: '';
        }
      }
      &::after {
        content: '\002022';
        position: relative;
        left: 1vw;
        display: inline-block;
      }
      &:last-child::after {
        content: '';
      }
    }
  }
</style>
